import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  HostListener,
} from "@angular/core";
import { Router } from "@angular/router";
import { FindCRSService, LogActivity } from "@app/core";
import {
  AgentListingActivity,
  Address,
} from "@app/core/models/agent-activity-model";
import { AuthenticationService } from "@app/core/services/authentication.service";
import { LogActivityService } from "@app/core/services/log-activity.service";
import * as _ from "lodash";
import { PaginationSetting } from "@app/core/components/grid/grid.model";
import { Subscription } from "rxjs";
import { AppConfig } from "@app/core/Utilities/app-config.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { RouteUrl } from "@app/core/utilities/route-url.service";
import { environment as env } from "@env/environment";
import { DomSanitizer } from "@angular/platform-browser";
import { ManageRecommendationsComponent } from "../manage-recommendations/manage-recommendations.component";
import { RecommendAgentComponent } from "../recommend-agent/recommend-agent.component";
import { EndorseAgentSkillsComponent } from "../endorse-agent-skills/endorse-agent-skills.component";
import { ChatEmitterService } from "@app/core/services/chat-emitter.service";

@Component({
  selector: "app-agent-detail",
  templateUrl: "./agent-detail.component.html",
  styleUrls: ["./agent-detail.component.scss"],
})
export class AgentDetailComponent implements OnInit {
  private routeSubscription: Subscription;
  public agentId: number = 0;
  public agent: any;
  public agentListingActivity: AgentListingActivity;
  public videoExtension = "video/mp4";
  private isVideoPlayedFirstTime: boolean = true;
  public activeRecommendSkillTabId = 0;
  public showRecommendAndSkillManage = false;
  public showRecommendAgent = false;
  public allowSendMessage = false;

  public showRecommendCounterLimit: number = 0;
  public showRecommendCounter: number = 0;
  public isShowLessRecommend = false;

  public logActivityModal: LogActivity;
  public ActivityBy: number = 0;
  public defaultPaginationSetting: PaginationSetting = {
    currentPage: 1,
    totalRecords: 50,
    itemPerPage: 2,
    selectedPageSize: ["50"],
  };

  public activityLogs = {
    ProfileVisit: "VisitProfile",
    ContactClicked: "ContactMeInitiate",
    WatchVideo: "WatchVideo",
  };

  public showTestingSiteAlert: boolean = false;

  @ViewChild("videoPlayer") videoplayer: ElementRef;

  public showContactAndRegerral: boolean = true;
  public listingActivityFilterData = [];
  public listingFilterStatus = [];
  public listingFilterObj = {
    groupingFilterName: "All",
    statusFilterName: "All",
  };
  public imgsSanitized: any;

  // Show more/less on Agent bio
  public showCounterLimit: number = 0;
  public showCounter: number = 0;
  public isShowLess = false;
  public showDefaultImage: boolean = false;

  subModalRef: BsModalRef;

  noOfBadgeDisplayOnSite: any;
  noOfBadgeDisplayOnTablet: any;
  noOfBadgeDisplayOnMobile: any;

  private totalLiWidth: number = 0;
  @HostListener("window:resize", ["$event"])
  sizeChange(event) {
    this.calculateTotalWidthForCRSLocation();
    this.toggleScrollableClassForCRSLocation();
  }

  constructor(
    private _findcsrService: FindCRSService,
    private _logActivityService: LogActivityService,
    private _authService: AuthenticationService,
    private _appConfig: AppConfig,
    private router: Router,
    public bsModalRef: BsModalRef,
    private routeUrl: RouteUrl,
    public sanit: DomSanitizer,
    public modalService: BsModalService,
    private chatEmitterService: ChatEmitterService
  ) {
    this.showCounterLimit = this._appConfig.showMoreLessLimit;
    this.showCounter = this.showCounterLimit;

    this.showRecommendCounterLimit = 2;
    this.showRecommendCounter = this.showRecommendCounterLimit;
  }

  @ViewChild("confirmation") confirmationContent: ElementRef;

  ngOnInit() {
    this.showTestingSiteAlert = this.router.url != "/" && env.envName == "BETA";
    setTimeout(() => {
      this.calculateTotalWidthForCRSLocation();
      this.toggleScrollableClassForCRSLocation();
    }, 1500);

    // this.routeSubscription = this.route.params.subscribe(params => {
    //   if (params) {
    //     window.localStorage.setItem("strAgentId", params["id"]);
    //     if (params["id"].split("-").length > 1) {
    //       this.agentId = params["id"].split("-")[params["id"].split("-").length - 1];

    if (this._authService.isUserLoggedIn()) {
      window.localStorage.setItem("strAgentId", "" + this.agentId + "");
      if (+this._authService.getUserInformation() === null) {
        this._authService
          .getMemberDetails(this._authService.getUserInformation()["ID"])
          .subscribe(
            (response: any) => {
              window.localStorage.setItem(
                "agentBasicDetails",
                JSON.stringify(response)
              );
              this.ActivityBy = +this._authService.getUserInformation()["ID"]
              this.showContactAndRegerral =
                this.ActivityBy == this.agentId ? false : true;
              this.showRecommendAndSkillManage =
                this.ActivityBy == this.agentId ? true : false;
              this.showRecommendAgent = this.ActivityBy != this.agentId;
              this.allowSendMessage = this.ActivityBy != this.agentId;
              this.logActivity(this.activityLogs.ProfileVisit);
            },
            (error: any) => { }
          );
      } else {
        this.logActivity(this.activityLogs.ProfileVisit);
      }
    } else {
      this.logActivity(this.activityLogs.ProfileVisit);
    }
    this.loadAgentDetail();
    //     } else {
    //       this._toaster.error('Something went wrong. Please try after sometime.')
    //       this.router.navigateByUrl('/');
    //     }
    //   } else {
    //     this._toaster.error('Something went wrong. Please try after sometime.')
    //     this.router.navigateByUrl('/');
    //   }
    // });
  }

  getImgsSanitized(imageURL: any) {
    if (imageURL) {
      return this.sanit.bypassSecurityTrustStyle(
        "url(" + imageURL + "), url(/assets/images/user-icon.png)"
      );
    }
  }

  ngOnDestroy() {
    // this.routeSubscription.unsubscribe();
  }

  onToggleOrPlayVideo(event: any) {
    if (this.isVideoPlayedFirstTime) {
      this.videoplayer.nativeElement.play();
      this.logActivity(this.activityLogs.WatchVideo);
      this.isVideoPlayedFirstTime = false;
    }
  }

  logActivity(logActivityFor: any) {
    this.logActivityModal = new LogActivity();
    this.logActivityModal.ActivityBy = this._authService.getUserInformation()
      ? +this._authService.getUserInformation()["ID"]
      : 0;
    this.logActivityModal.Activity = logActivityFor; // Activity name
    this.logActivityModal.AgentID = this.agentId; // Agent id for visiting agent profile
    this.showContactAndRegerral =
      this.logActivityModal.ActivityBy == this.agentId ? false : true;
    this.showRecommendAndSkillManage =
      this.logActivityModal.ActivityBy === this.agentId &&
        this._authService.isUserLoggedIn()
        ? true
        : false;
    this.showRecommendAgent =
      this.logActivityModal.ActivityBy !== this.agentId &&
      this._authService.isUserLoggedIn();
    this.allowSendMessage =
      this.logActivityModal.ActivityBy !== this.agentId &&
      this._authService.isUserLoggedIn();
    this._logActivityService.logActivity(this.logActivityModal).subscribe(
      (response: any) => { },
      (error: any) => { }
    );
  }

  onListingActivityGroupingFilterChange(filterName: any) {
    this.listingFilterObj.groupingFilterName = filterName;
    if (filterName == "All") {
      this.listingActivityFilterData = this.agent.listingActivity;
      this.defaultPaginationSetting.currentPage = 1;
      this.defaultPaginationSetting.totalRecords = this.listingActivityFilterData.length;
    } else {
      this.setCityStateFilter(filterName);
      this.defaultPaginationSetting.currentPage = 1;
      this.defaultPaginationSetting.totalRecords = this.listingActivityFilterData.length;
      this.listingFilterObj.statusFilterName = "All";
    }
  }

  setCityStateFilter(filterName: any) {
    let city = filterName.split("-")[0];
    let state = filterName.split("-")[1];

    this.listingActivityFilterData = [];
    this.agent.listingActivity.forEach((element) => {
      if (element.Address.City === city && element.Address.State === state) {
        this.listingActivityFilterData.push(element);
      }
    });
  }

  onListingActivityStatusFilterChange(stausFilterName) {
    this.setStatusFilter(stausFilterName);
    this.defaultPaginationSetting.currentPage = 1;
    this.defaultPaginationSetting.totalRecords = this.listingActivityFilterData.length;
    this.listingFilterObj.statusFilterName = stausFilterName;
  }

  setStatusFilter(stausFilterName: any) {
    this.listingFilterObj.statusFilterName = stausFilterName;
    if (stausFilterName != "All") {
      if (this.listingFilterObj.groupingFilterName == "All") {
        // Case: Other-All case
        let tempArrFilter = [];
        this.agent.listingActivity.forEach((element) => {
          if (element.ListingStatus == stausFilterName) {
            tempArrFilter.push(element);
          }
        });
        this.listingActivityFilterData = tempArrFilter;
      } else {
        // Case: Other-Other case
        this.setCityStateFilter(this.listingFilterObj.groupingFilterName);
        let tempArrFilter = [];
        this.listingActivityFilterData.forEach((element) => {
          if (element.ListingStatus == stausFilterName) {
            tempArrFilter.push(element);
          }
        });
        this.listingActivityFilterData = tempArrFilter;
      }
    } else {
      if (this.listingFilterObj.groupingFilterName == "All") {
        // Case: All-All case
        this.listingActivityFilterData = this.agent.listingActivity;
      } else {
        // Case: All-Other case
        this.setCityStateFilter(this.listingFilterObj.groupingFilterName);
      }
    }
  }

  setStatusFilterOnly(filterName, list) {
    let returnList = [];
    list.forEach((element) => {
      if (element.ListingStatus == filterName) {
        returnList.push(element);
      }
    });
    return returnList;
  }

  pageChange(event: any) {
    this.defaultPaginationSetting.currentPage = event.page;

    // // Case-> Grouping : status
    if (this.listingFilterObj.groupingFilterName != "All") {
      if (this.listingFilterObj.statusFilterName != "All") {
        // Case: Other:Other
        this.setCityStateFilter(this.listingFilterObj.groupingFilterName);
        let temp_list = this.setStatusFilterOnly(
          this.listingFilterObj.statusFilterName,
          this.listingActivityFilterData
        );
        this.listingActivityFilterData = temp_list.slice(
          (this.defaultPaginationSetting.currentPage - 1) *
          this.defaultPaginationSetting.itemPerPage,
          this.defaultPaginationSetting.currentPage *
          this.defaultPaginationSetting.itemPerPage
        );
      } else {
        // Case: Other:All
        this.setCityStateFilter(this.listingFilterObj.groupingFilterName);
        this.listingActivityFilterData = this.listingActivityFilterData.slice(
          (this.defaultPaginationSetting.currentPage - 1) *
          this.defaultPaginationSetting.itemPerPage,
          this.defaultPaginationSetting.currentPage *
          this.defaultPaginationSetting.itemPerPage
        );
      }
    } else {
      if (this.listingFilterObj.statusFilterName != "All") {
        // Case: All:Other
        this.setStatusFilter(this.listingFilterObj.statusFilterName);
        this.listingActivityFilterData = this.listingActivityFilterData.slice(
          (this.defaultPaginationSetting.currentPage - 1) *
          this.defaultPaginationSetting.itemPerPage,
          this.defaultPaginationSetting.currentPage *
          this.defaultPaginationSetting.itemPerPage
        );
      } else {
        // Case: All:All
        this.listingActivityFilterData = this.agent.listingActivity.slice(
          (this.defaultPaginationSetting.currentPage - 1) *
          this.defaultPaginationSetting.itemPerPage,
          this.defaultPaginationSetting.currentPage *
          this.defaultPaginationSetting.itemPerPage
        );
      }
    }
  }

  loadAgentDetail() {
    this._findcsrService
      .getAgentDetail(this.agentId)
      .subscribe((agentDetails) => {
        if (!agentDetails.AgentFeaturedListing) {
          agentDetails.AgentFeaturedListing = [];
        }
        if (!agentDetails.AgentCities) {
          agentDetails.AgentCities = [];
        }

        let officeCity = new OfficeCity();
        officeCity.City = agentDetails.OfficeCity;
        officeCity.State = agentDetails.OfficeState;

        let mergedCities = agentDetails.AgentFeaturedListing.concat(
          agentDetails.AgentCities
        );
        mergedCities.push(officeCity);
        mergedCities = _.uniqBy(mergedCities, function (e) {
          return e.City;
        });
        agentDetails.mergedCities = mergedCities.sort((a, b) =>
          a.City > b.City ? 1 : -1
        );

        if (!agentDetails.AgentRRCCertifications) {
          agentDetails.AgentRRCCertifications = [];
        }
        if (!agentDetails.AgentNARCertifications) {
          agentDetails.AgentNARCertifications = [];
        }
        agentDetails.AgentCertification = [];
        agentDetails.AgentCertification = agentDetails.AgentRRCCertifications.concat(
          agentDetails.AgentNARCertifications
        );

        this.agent = agentDetails;
        this.agent.Bio = this.agent.Bio.trimStart("\n");
        if (this.agent.AgentVideo.length) {
          var ext = /(?:\.([^.]+))?$/.exec(
            this.agent.AgentVideo[0].VideoUrl
          )[1];

          if (ext == "m4v") ext = "mp4";
          if (ext == "ogv") ext = "ogg";
          this.videoExtension = "video/" + ext;

          // // Un-comment below lines for testing purpose in local env.
          // // this.agent.AgentVideo[0].VideoUrl = 'assets/AgentVideo/baa63d7b-d25d-4512-bba1-ee6cb277d310_6700204.mp4';
        }

        if (agentDetails.ActiveListingFilter) {
          if (agentDetails.ActiveListingFilter.length) {
            this.listingFilterStatus.push({ Status: "All" });
            agentDetails.ActiveListingFilter.forEach((element) => {
              this.listingFilterStatus.push(element);
            });
            // this.listingFilterStatus = agentDetails.ActiveListingFilter;
          }
        }

        if (agentDetails.ListingActivityGrouping) {
          if (agentDetails.ListingActivityGrouping.length) {
            this.agent.listingActivityGrouping =
              agentDetails.ListingActivityGrouping;
          }
        }

        if (agentDetails.ActiveListing) {
          if (agentDetails.ActiveListing.length) {
            this.agent.listingActivity = [];

            let i = 0;
            agentDetails.ActiveListing.forEach((element) => {
              this.agentListingActivity = new AgentListingActivity();
              this.agentListingActivity.id = element.id;

              if (element.Photos) {
                if (element.Photos.Photo && element.Photos.Photo.length) {
                  this.agentListingActivity.MediaURL =
                    element.Photos.Photo[0].MediaURL;
                } else {
                  this.agentListingActivity.MediaURL = "";
                }
              } else {
                this.agentListingActivity.MediaURL = "";
              }

              if (element.PropertyType) {
                this.agentListingActivity.PropertyType =
                  element.PropertyType["@otherDescription"];
              } else {
                this.agentListingActivity.PropertyType = "";
              }

              if (element.ListPrice) {
                this.agentListingActivity.ListPrice =
                  element.ListPrice["#text"];
              } else {
                this.agentListingActivity.ListPrice = "";
              }

              this.agentListingActivity.Address = new Address();
              if (element.Address) {
                if (element.Address["FullStreetAddress"]) {
                  this.agentListingActivity.Address.FullStreetAddress = element
                    .Address["FullStreetAddress"]
                    ? element.Address["FullStreetAddress"]
                    : "";
                } else {
                  this.agentListingActivity.Address.FullStreetAddress = "";
                }

                if (element.Address["City"]) {
                  this.agentListingActivity.Address.City = element.Address[
                    "City"
                  ]
                    ? element.Address["City"]
                    : "";
                } else {
                  this.agentListingActivity.Address.City = "";
                }

                if (element.Address["StateOrProvince"]) {
                  this.agentListingActivity.Address.State = element.Address[
                    "StateOrProvince"
                  ]
                    ? element.Address["StateOrProvince"]
                    : "";
                } else {
                  this.agentListingActivity.Address.State = "";
                }
              }

              // if (element.Address) {
              //   if (element.Address.Office && element.Offices.Office.length) {
              //     this.agentListingActivity.Address = element.Offices.Office.Address["FullStreetAddress"];
              //   } else { this.agentListingActivity.Address = '';}
              // }
              // else { this.agentListingActivity.Address = '';}

              // this.agentListingActivity.MediaURL = element.Photos.Photo[i].MediaURL;
              // this.agentListingActivity.PropertyType = element.PropertyType["@otherDescription"];
              // this.agentListingActivity.ListPrice = element.ListPrice["#text"];
              // this.agentListingActivity.Address = element.Offices.Office.Address["FullStreetAddress"];
              this.agentListingActivity.Bedrooms = element.Bedrooms;
              this.agentListingActivity.Bathrooms = element.Bathrooms;
              this.agentListingActivity.LotSize = "";
              if (element.LotSize) {
                if (element.LotSize["#text"]) {
                  this.agentListingActivity.LotSize = element.LotSize["#text"];
                }
                if (element.LotSize["@commons:areaUnits"]) {
                  this.agentListingActivity.LotSize =
                    this.agentListingActivity.LotSize +
                    " " +
                    element.LotSize["@commons:areaUnits"];
                }
              }

              this.agentListingActivity.ListingStatus = element.ListingStatus
                ? element.ListingStatus
                : "Closed";

              i++;
              this.agent.listingActivity.push(this.agentListingActivity);
              this.listingActivityFilterData.push(this.agentListingActivity);
            });
            this.defaultPaginationSetting.totalRecords = this.listingActivityFilterData.length;
            this.defaultPaginationSetting.currentPage = 1;
          }
        }
        this.agent.AgentBadgeRibbon = _.orderBy(this.agent.AgentBadgeRibbon, ["Priority"], ["asc"]);
        this.noOfBadgeDisplayOnSite = +agentDetails.NoOfBadgeDisplayOnSite;
        this.noOfBadgeDisplayOnTablet = +agentDetails.NoOfBadgeDisplayOnTablet;
        this.noOfBadgeDisplayOnMobile = +agentDetails.NoOfBadgeDisplayOnMobile;
      });
  }

  setDefaultimage(event: any) {
    event.srcElement.src = "/assets/images/user-icon.png";
  }

  setDefaultImageForListingActivity(event: any) {
    event.srcElement.src = "/assets/images/No-Image-Available.png";
  }

  getDesigneeFullYear(date) {
    return date ? new Date(date).getFullYear() : "";
  }

  goToSendReferral(id: any) {
    window.localStorage.setItem("sendReferralID", id);
    window.open("/sendreferral/" + id, "_blank");
  }

  goToActivityListingDetails(id: any) {
    window.open("/property-info/" + id, "_blank");
  }

  openModal(content) {
    if (this._authService.isUserLoggedIn()) {
      // If user id logged in
      this.router.navigateByUrl(
        "/" + this.routeUrl.contactMe + "/" + this.agentId
      );
    } else {
      // Open Confirmation Modal
      // this._modalService.open(content, { ariaLabelledBy: "modal-basic-title", size: 'sm' }).result.then(result => {},reason => {});
    }
  }

  contactMeClicked(continueAsGuest: boolean = false) {
    // var url = new URL(window.location.href.toString());
    // this._modalService.dismissAll();

    // this.router.navigateByUrl('/'+this.routeUrl.contactMe+'/' + this.agentId);
    window.open("/" + this.routeUrl.contactMe + "/" + this.agentId, "_blank");
  }

  onShowMoreLessClick() {
    this.isShowLess = !this.isShowLess;
    if (this.isShowLess) {
      this.showCounter = this.agent.Bio.length;
    } else {
      this.showCounter = this.showCounterLimit;
    }
  }

  onShowMoreLessRecommendClick() {
    this.isShowLessRecommend = !this.isShowLessRecommend;
    if (this.isShowLess) {
      this.showRecommendCounter = this.agent.AgentRecommendation.length;
    } else {
      this.showRecommendCounter = this.showRecommendCounterLimit;
    }
  }

  calculateTotalWidthForCRSLocation() {
    this.totalLiWidth = 0;
    if (document.getElementsByClassName("tabset-scrollable").length) {
      var allLi =
        document.getElementsByClassName("tabset-scrollable").length > 1
          ? document
            .getElementsByClassName("tabset-scrollable")[1]
            .getElementsByClassName("nav-item")
          : [];
      for (var i = 0; i < allLi.length; i++) {
        this.totalLiWidth = this.totalLiWidth + allLi[i]["offsetWidth"];
      }
    }
  }

  toggleScrollableClassForCRSLocation() {
    if (
      document.getElementsByClassName("contain-block").length &&
      document.getElementsByClassName("nav-tabs").length
    ) {
      if (
        this.totalLiWidth + 100 >
        document.getElementsByClassName("contain-block")[0]["offsetWidth"]
      ) {
        document
          .getElementsByClassName("nav-tabs")[0]
          .classList.add("scroll-overflow");
        if (document.getElementsByClassName("nav-tabs")[1]) {
          document
            .getElementsByClassName("nav-tabs")[1]
            .classList.add("scroll-overflow");
        }
      } else {
        document
          .getElementsByClassName("nav-tabs")[0]
          .classList.remove("scroll-overflow");
        if (document.getElementsByClassName("nav-tabs")[1]) {
          document
            .getElementsByClassName("nav-tabs")[1]
            .classList.remove("scroll-overflow");
        }
      }
    }
  }

  // Recommend Agent
  changeTab(event) {
    if (event.id == "skill") {
      this.activeRecommendSkillTabId = 1;
    } else {
      this.activeRecommendSkillTabId = 0;
    }
  }

  openManageModal() {
    if (this.activeRecommendSkillTabId == 1) {
      // this.manageSkill();
    } else {
      this.manageRecommendation();
    }
  }

  recommendAgent() {
    const initialState = {
      agentFirstName: this.agent.FirstName,
      agentLastName: this.agent.LastName,
      agentImage: this.agent.ImageUrl,
      agentId: this.agentId,
    };
    this.subModalRef = this.modalService.show(
      RecommendAgentComponent,
      Object.assign({ initialState, class: "modal-lg", backdrop: "static" })
    );
    this.subModalRef.content.closeBtnName = "Close";
    this.subscribeModalHideEvent();
  }

  subscribeModalHideEvent() {
    this.modalService.onHide.subscribe((result) => {
      this.loadAgentDetail();
    });
  }

  endorseAgentSkills() {
    const initialState = {
      agentFirstName: this.agent.FirstName,
      agentLastName: this.agent.LastName,
      agentId: this.agentId,
    };
    this.subModalRef = this.modalService.show(
      EndorseAgentSkillsComponent,
      Object.assign({ initialState, class: "modal-lg", backdrop: "static" })
    );
    this.subModalRef.content.closeBtnName = "Close";
    this.subscribeModalHideEvent();
  }

  manageRecommendation() {
    const initialState = { agentId: this.agentId };
    this.subModalRef = this.modalService.show(ManageRecommendationsComponent, {
      initialState,
      class: "modal-lg",
      backdrop: "static",
    });
    this.subModalRef.content.closeBtnName = "Close";
    this.subscribeModalHideEvent();
  }

  closeModal() {
    document.getElementsByTagName("html")[0].classList.remove("modal-open");
    this.bsModalRef.hide();
  }

  updateParentView() {
    this.loadAgentDetail();
  }

  sendMessage(id) {
    this.chatEmitterService.openUserChatWindow(id);
  }

  redirectMessage(value) {
    this.bsModalRef.hide();
    this.router.navigate([`user/direct/message/0`], {
      queryParams: {
        rid: value.ID,
      },
    });
  }

  getBadgesAndRibbon(value) {
    let dataValue = value;
    if (dataValue) {
      dataValue = _.orderBy(dataValue.filter((x) => x.Priority > 0), ["Priority"], ["asc"]);
      return dataValue;
    }
    return [];
  }

  getBadgesCount(value, count): number {
    if (!value) {
      return 0;
    } else {
      const zeroPriorityCount = value.filter((x) => x.Priority === 0).length;
      let pendingCount = value.filter((x) => x.Priority > 0).length - count;
      return pendingCount = pendingCount > 0 ? pendingCount : 0;
      // return (zeroPriorityCount + pendingCount) > 0 ? (zeroPriorityCount + pendingCount) : 0;
    }
  }
  getBadgesPopoverValue(value, count) {
    const remainingBadges = {
      badges: []
    };
    const displayedBadges = _.slice(this.getBadgesAndRibbon(value), 0, count);
    remainingBadges.badges = _.difference(value, displayedBadges);
    remainingBadges.badges = remainingBadges.badges.filter((x) => x.Priority > 0);
    return remainingBadges;
  }
}
export class OfficeCity {
  AgentID: number;
  City: string;
  Country: string;
  CreatedBy: string;
  DateCreated: string;
  DateModified: string;
  ExpirationDate: string;
  ID: number;
  ModifiedBy: string;
  State: string;
}
